import { render, staticRenderFns } from "./ContentSelect.vue?vue&type=template&id=9b552116&scoped=true"
import script from "./ContentSelect.vue?vue&type=script&lang=js"
export * from "./ContentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b552116",
  null
  
)

export default component.exports